export default __webpack_public_path__ + "static/media/fleets.274d69e2.png";